import React from "react";
import clsx from "clsx";
import { Button as BootstrapButton } from "react-bootstrap";
import { Skeleton } from "components";

const Button = ({
	onClick,
	title,
	value,
	variant = "primary",
	shape,
	size,
	type = "button",
	btnIcon = false,
	icon,
	iconPosition = "left",
	minWidth,
	active = false,
	disabled = false,
	block = false,
	isLoading = false,
	pruningLine = false,
	href,
	target,
	as,
	tabIndex,
	className,
	style,
	children,
	to,
	form,
}) => {
	const handleOnClick = e => {
		if (disabled) {
			return;
		}
		if (typeof onClick === "function") {
			onClick(e);
		}
	};

	const shapeClass = shape === "circle" && "ar-btn-circle";
	const classBtnIcon = btnIcon && "ar-btn-icon";
	const skeletonVariant = shape === "circle" ? "circle" : "rect";
	const isPruningLine = pruningLine ? "pruningLine" : null;

	return (
		<BootstrapButton
			className={clsx(shapeClass, className, classBtnIcon)}
			onClick={handleOnClick}
			disabled={disabled || isLoading}
			variant={variant}
			bsPrefix="ar-btn"
			active={active}
			as={as}
			block={block}
			href={href}
			size={size}
			target={target}
			type={type}
			tabIndex={tabIndex}
			style={{
				...style,
				minWidth,
			}}
			title={title}
			to={to}
			form={form}
		>
			{isLoading ? (
				<Skeleton variant={skeletonVariant} className="skeletonInBtn" />
			) : (
				<>
					{icon && iconPosition === "left" && (
						<span className="icon">{icon}</span>
					)}
					{(value || children) && (
						<span className={clsx(isPruningLine)}>
							{children || value}
						</span>
					)}
					{icon && iconPosition === "right" && (
						<span className="icon">{icon}</span>
					)}
				</>
			)}
		</BootstrapButton>
	);
};

export default Button;
